import Vue from "vue";
import GtImage from "@/components/common/GtImage.vue";

// 全局组件
Vue.component("gt-image", GtImage);
